import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rutavix/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rutavix/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExperiencePage"] */ "/var/www/rutavix/frontend/src/components/ExperiencePage.tsx");
